import type { AlertCounts } from '@/components/layout/nav-groups'
import { useAlerts } from '@/features/alerts/api/queries'

/**
 * The member's alert counts for the Alerts rows — "Active · 3", "Expired · 2"
 * — in the sidebar and the Alerts strip alike: the lengths of the same two
 * lists the Alerts page reads, so no extra request. A list still loading (or
 * failed) leaves its count off rather than showing a number nobody measured.
 */
export function useAlertCounts(): AlertCounts {
  const active = useAlerts('active')
  const expired = useAlerts('expired')
  return {
    ...(active.data === undefined ? {} : { active: active.data.length }),
    ...(expired.data === undefined ? {} : { expired: expired.data.length }),
  }
}
